<template>
	<div class="message_attachment">
		<lightbox v-if="attachment.type == 'image'" :options="{rel: 'lightbox[chat-main]'}" :images="[{ src: attachment.url, thumb: attachment.thumburl, rel: 'lightbox[chat-main]' }]" :id="msgcreated.toString()"></lightbox>
		<video controls playsinline preload="metadata" v-if="attachment.type == 'video'">
			<source :src="attachment.url + '#t=0.1'" type="video/mp4">
		</video>
	</div>
</template>

<script>
import Event from '../event.js';
import Lightbox from 'vue-simple-lightbox';
export default {
	props: ["attachment", "msgcreated"],
	components: {
		Lightbox,
	},
	data() {
		return {
			current_user: window.Laravel.user
		};
	}
};
</script>